export const tutorials = [
  {
    "title": "Ampoules LED",
    "message": "Privilégiez l'utilisation d'ampoules LED : elles consomment nettement moins d'énergie et ont une durée de vie supérieure à celle des ampoules traditionnelles."
  },
  {
    "title": "Éviter le mode veille",
    "message": "Débranchez vos appareils électroniques ou utilisez des multiprises à interrupteur pour stopper la consommation cachée liée aux modes veille."
  },
  {
    "title": "Thermostat programmable",
    "message": "Utilisez un thermostat programmable pour adapter la température de votre logement à vos habitudes de présence et réduire vos dépenses de chauffage."
  },
  {
    "title": "Isolation des ouvertures",
    "message": "Limitez les pertes de chaleur en isolant correctement vos fenêtres et portes, par exemple à l'aide de joints ou de coupe-froid."
  },
  {
    "title": "Lavage à basse température",
    "message": "Lavez vos vêtements à basse température pour économiser l'énergie habituellement nécessaire à la chauffe de l'eau de la machine."
  },
  {
    "title": "Confort thermique",
    "message": "Adaptez votre tenue vestimentaire en ajoutant une épaisseur plutôt que d'allumer systématiquement un chauffage d'appoint énergivore."
  },
  {
    "title": "Étiquette énergétique",
    "message": "Lors du remplacement de vos appareils électroménagers, choisissez-les bien classés sur l'étiquette énergétique pour une meilleure performance."
  },
  {
    "title": "Lumière naturelle",
    "message": "Profitez autant que possible de la lumière du jour en dégageant vos fenêtres, ce qui permet de limiter le recours à l'éclairage artificiel."
  },
  {
    "title": "Température du chauffe-eau",
    "message": "Réglez la température de votre chauffe-eau entre 55°C et 60°C. C'est idéal pour éviter les proliférations bactériennes tout en réalisant des économies."
  },
  {
    "title": "Cuisson couverte",
    "message": "Placez un couvercle sur vos casseroles lors de la cuisson. Cela permet de retenir la chaleur, de cuire plus vite et d'économiser de l'énergie."
  },
  {
    "title": "Isolation nocturne",
    "message": "Fermez vos volets et tirez les rideaux la nuit. Cette couche d'air emprisonnée constitue un bon isolant contre le froid extérieur."
  },
  {
    "title": "Séchage naturel",
    "message": "Dans la mesure du possible, faites sécher votre linge à l'air libre plutôt que d'utiliser le sèche-linge (qui est très gourmand en électricité)."
  },
  {
    "title": "Privilégier les douches",
    "message": "Prendre une douche rapide nécessite généralement beaucoup moins d'eau (et donc de chauffage de l'eau) que de prendre un bain."
  },
  {
    "title": "Brassage de l'air",
    "message": "L'utilisation d'un ventilateur de plafond garantit une meilleure répartition de l'air chaud en hiver et rafraîchit la pièce l'été, limitant la climatisation."
  },
  {
    "title": "Éclairage extérieur ciblé",
    "message": "Équipez vos éclairages extérieurs de détecteurs de présence et de minuteries pour éviter de laisser la lumière allumée de manière prolongée."
  },
  {
    "title": "Piles rechargeables",
    "message": "Préférez l'utilisation de piles rechargeables pour limiter l'impact environnemental et énergétique lié à l'extraction et la fabrication de piles jetables."
  },
  {
    "title": "Aération et humidité",
    "message": "Aérez régulièrement les pièces pour évacuer l'humidité. Un air sec demande beaucoup moins d'énergie pour être chauffé qu'un air humide."
  },
  {
    "title": "Dégivrage du congélateur",
    "message": "Lorsque du givre s'accumule, votre congélateur fournit plus d'efforts. Dégivrez-le régulièrement pour qu'il conserve un fonctionnement économe."
  },
  {
    "title": "Ventilation ciblée",
    "message": "Activez les extracteurs d'air des salles de bain et de la cuisine pour évacuer rapidement l'humidité et optimiser l'effort de la climatisation ou du chauffage."
  },
  {
    "title": "Programmation horaire",
    "message": "Aidez-vous de prises programmables pour allumer et éteindre automatiquement certains de vos appareils selon vos tranches horaires (par ex. heures creuses)."
  },
  {
    "title": "Décongélation douce",
    "message": "Laissez décongeler vos aliments lentement dans le réfrigérateur : le froid dégagé aidera le fonctionnement de ce dernier, tout en vous évitant d'utiliser le micro-ondes."
  },
  {
    "title": "Mode économie d'énergie",
    "message": "Configurez convenablement la mise en veille de votre ordinateur afin de réduire sa consommation d'énergie lorsqu'il est allumé mais inactif."
  },
  {
    "title": "Luminosité des écrans",
    "message": "Au travail comme de nuit, réduisez la luminosité de vos moniteurs et téléviseurs pour diminuer leur consommation tout en préservant votre fatigue visuelle."
  },
  {
    "title": "Protection estivale",
    "message": "L'été, fermez en partie les volets ou les stores exposés au soleil afin de bloquer la chaleur à l'extérieur et éviter d'abuser de la climatisation."
  },
  {
    "title": "Isolation des sols",
    "message": "La pose de tapis épais, particulièrement sur du carrelage, apporte un meilleur confort thermique et limite le besoin d'augmenter le chauffage pour compenser la sensation de froid."
  },
  {
    "title": "Anticipation des cuissons",
    "message": "Sortez les aliments froids à température ambiante un peu avant de les cuire afin de réduire le temps de cuisson dont ils auront besoin."
  },
  {
    "title": "Éteindre la box Internet",
    "message": "Pensez à éteindre votre box Internet et votre décodeur TV la nuit ou lors de vos absences, ces appareils consommant de l'énergie en continu."
  },
  {
    "title": "Extinction des lumières",
    "message": "Prenez l'habitude d'éteindre systématiquement la lumière de la pièce que vous quittez pour éviter le gaspillage inutile."
  },
  {
    "title": "Multiprises à interrupteur",
    "message": "Regroupez vos appareils électroniques sur des multiprises à interrupteur pour couper d'un seul geste l'accès au courant lorsqu'ils ne sont pas nécessaires."
  },
  {
    "title": "Entretien de la chaudière",
    "message": "Un entretien annuel et régulier de votre chaudière allonge sa durée de vie et maintient ses performances énergétiques dans un état optimal."
  }
]